/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import 'moment/locale/pt';
import { Box, Button, Modal, Typography } from '@mui/material';
import moment from 'moment';
import FixedContainer from '../../components/Container';
import LoadingComponent from '../../components/LoadingComponent';
import CustomizedTables from '../../components/Table';
import NewSentinelModal from './components/newSentinelModal';
import PaginationRounded from '../../components/NewPagination';
import { GetFetch } from '../../services/apiBase';

const Sentinels = props => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);

  const [s3Objects, setS3Objects] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(0);

  const [s3Bucket, setS3BUcket] = useState(null);
  
  const COLUMNSTABLE = [
    {
      headerName: 'Nome do arquivo',
      type: 'deafult',
      value: {
        first: {
          value: 'Key'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Data de registro',
      type: 'timedate',
      value: {
        first: {
          value: 'LastModified'
        }
      }
    },
  ]

  const handleOpenNewModal = () => {
    setOpenNewModal(true)
  }

  const handleClose = () => {
    setOpenNewModal(false);
  }

  const getS3Data = useCallback(async () => {
    setLoading(true)
    try {

      const configResponse = await GetFetch('/system/config?key=BUCKET_SENTINELA');
      const bucket = configResponse.data[0].value;
      setS3BUcket(bucket);
      const response = await GetFetch(`/lake/bucket-files?bucket=${bucket}`);

      // setLimit(response.data.perPage);
      // setTotalPages(response.data.lastPage);
      const numberOfPages = Math.ceil(response.data.length / limit);
      setTotalPages(numberOfPages);

      // filter only pdf files
      setS3Objects(response.data.Contents.filter((obj) => obj.Key.endsWith('.pdf')));

      setError(false)
    } catch (error) {
      console.log('error loading sentinelas data');
      setError(true)
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, [currentPage]);

  const tableComponent = () => {
    return (
      <Box>
        {s3Objects && s3Objects.length > 0
          ? 
          <>
            <CustomizedTables
              data={s3Objects}
              columns={COLUMNSTABLE}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas sentinelas
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as sentinelas
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    getS3Data()
  }, []);

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Registro de Sentinelas no Repositório
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
              
            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
            s3Objects && s3Objects.length === 0 ? 
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não existem sentinelas para listar
                </Typography>
              </Box>
              :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openNewModal}
        onClose={handleClose}
      >
        <NewSentinelModal
          onClose={handleClose}
          getList={getS3Data}
          bucket={s3Bucket}
        />
      </Modal>
    </>
  );
}

export default Sentinels;
